import { BaseService } from "./base.service";
import { assert } from "@/core";
export class ProgramTemplateService extends BaseService {
  constructor() {
    super("program-templates");
  }

  async getListProgramTemplateCriteriaByUniId(id = window.required()) {
    assert.id(id, { required: true });

    const response = await this.request({ auth: true }).get(
      `${this.entity}/${id}/criteria`,
      {}
    );
    return response.data;
  }
}
